import { Link, createFileRoute } from '@tanstack/react-router';
import { POSTS } from '~/content/blog';
import { buildHead } from '~/seo/site';

export const Route = createFileRoute('/blog/')({
  head: () =>
    buildHead({
      title: 'Blog',
      description:
        'Guides, tutorials, and tactics for beatmakers and producer-battle competitors. How to win, how to mix, how to make beats in any genre.',
      path: '/blog',
    }),
  component: BlogIndex,
});

function BlogIndex() {
  return (
    <section className="mx-auto max-w-3xl px-4 py-12 space-y-10">
      <header className="space-y-3">
        <h1 className="text-3xl font-bold tracking-tight">Blog</h1>
        <p className="text-muted-foreground">
          Guides for beatmakers, tactics for battle competitors, and the occasional opinion piece.
        </p>
      </header>

      <ul className="space-y-6">
        {POSTS.map((p) => (
          <li
            key={p.meta.slug}
            className="rounded-md border border-border bg-card p-5 hover:border-primary/40 transition-colors"
          >
            <Link to="/blog/$slug" params={{ slug: p.meta.slug }} className="block space-y-2">
              <div className="flex flex-wrap items-center gap-3 font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
                <span>{p.meta.category}</span>
                <span aria-hidden>·</span>
                <span>{p.meta.readMin} min read</span>
                <span aria-hidden>·</span>
                <time dateTime={p.meta.date}>{p.meta.date}</time>
              </div>
              <h2 className="text-xl font-semibold leading-tight">{p.meta.title}</h2>
              <p className="text-sm text-muted-foreground">{p.meta.description}</p>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
